/* eslint-disable */
/**
 * Ezamiyyə Xərcləri Kalkulyatoru (2026)
 * Hüquqi Spesifikasiya: Targeted Final Legal Correction
 * 
 * Hüquqi Mənbələr:
 * - AR Əmək Məcəlləsi (maddə 164, 177, 179, 180, 181)
 * - AR Vergi Məcəlləsi (maddə 98.3, 102.1.14.2, 109.7)
 * - AR Nazirlər Kabinetinin 25 yanvar 2008-ci il tarixli 14 nömrəli Qərarı (04.04.2024 tarixli 200 nömrəli Qərarla edilmiş dəyişikliklər daxil olmaqla)
 * - AR Maliyyə Nazirliyinin "İşçilərin Ezamiyyə Qaydaları" (Q-01 nömrəli Qərar)
 * - AR Dövlət Vergi Xidmətinin (DVX) rəsmi inzibati izahları
 */

export const DOMESTIC_NORMS = {
  baku: {
    id: 'baku',
    name: 'Bakı şəhəri',
    dailyNorm: 125.0,
    hotelPercent: 0.70, // 87.50 AZN
    dailyPercent: 0.30, // 37.50 AZN
    currency: 'AZN',
  },
  nakhchivan: {
    id: 'nakhchivan',
    name: 'Naxçıvan şəhəri',
    dailyNorm: 100.0,
    hotelPercent: 0.70, // 70.00 AZN
    dailyPercent: 0.30, // 30.00 AZN
    currency: 'AZN',
  },
  ganja_sumgayit: {
    id: 'ganja_sumgayit',
    name: 'Gəncə və Sumqayıt şəhərləri',
    dailyNorm: 95.0,
    hotelPercent: 0.70, // 66.50 AZN
    dailyPercent: 0.30, // 28.50 AZN
    currency: 'AZN',
  },
  other_regions: {
    id: 'other_regions',
    name: 'Digər şəhər, rayon mərkəzləri, qəsəbə və kəndlər',
    dailyNorm: 90.0,
    hotelPercent: 0.70, // 63.00 AZN
    dailyPercent: 0.30, // 27.00 AZN
    currency: 'AZN',
  },
};

/**
 * NK №14 1 nömrəli Əlavə (Cari E-Qanun Mətninə Tam Uyğunlaşdırılmış Rəsmi Cədvəl)
 * Xarici ezamiyyələrdə norma bölgüsü:
 * - 60% mehmanxana xərcləri
 * - 40% gündəlik xərclər (yemək və şəhərdaxili nəqliyyat)
 * 
 * Şəhər normaları yalnız rəsmi NK №14 cədvəlində xüsusi sətirlə ayrılmış hallar üçün tətbiq olunur.
 * Əks halda ölkənin ümumi norması əsas götürülür.
 */
export const FOREIGN_NORMS = {
  // Gürcüstan (Tbilisi 200 USD, Digər şəhərlər 155 USD; Batumi üçün ayrıca norma yoxdur)
  georgia_tbilisi: { id: 'georgia_tbilisi', country: 'Gürcüstan', city: 'Tbilisi', dailyNorm: 200.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  georgia_other: { id: 'georgia_other', country: 'Gürcüstan', city: 'Digər şəhərlər (Batumi daxil)', dailyNorm: 155.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Böyük Britaniya (London 280 GBP, Digər şəhərlər 250 GBP)
  uk_london: { id: 'uk_london', country: 'Böyük Britaniya', city: 'London', dailyNorm: 280.0, currency: 'GBP', hotelPercent: 0.60, dailyPercent: 0.40 },
  uk_other: { id: 'uk_other', country: 'Böyük Britaniya', city: 'Digər şəhərlər', dailyNorm: 250.0, currency: 'GBP', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Rusiya (Moskva və Sankt-Peterburq birlikdə 260 USD, Digər şəhərlər 170 USD)
  russia_moscow: { id: 'russia_moscow', country: 'Rusiya', city: 'Moskva', dailyNorm: 260.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  russia_spb: { id: 'russia_spb', country: 'Rusiya', city: 'Sankt-Peterburq', dailyNorm: 260.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  russia_other: { id: 'russia_other', country: 'Rusiya', city: 'Digər şəhərlər', dailyNorm: 170.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Fransa (Paris 300 EUR, Digər şəhərlər 250 EUR)
  france_paris: { id: 'france_paris', country: 'Fransa', city: 'Paris', dailyNorm: 300.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },
  france_other: { id: 'france_other', country: 'Fransa', city: 'Digər şəhərlər', dailyNorm: 250.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Almaniya (Ölkə norması 250 EUR; Berlin/Frankfurt/Münhen üçün ayrıca norma yoxdur)
  germany: { id: 'germany', country: 'Almaniya', city: 'Bütün şəhərlər (Berlin, Frankfurt, Münhen daxil)', dailyNorm: 250.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },

  // ABŞ (Nyu-York 450 USD, Digər şəhərlər 350 USD; Vaşinqton üçün ayrıca norma yoxdur)
  usa_newyork: { id: 'usa_newyork', country: 'ABŞ', city: 'Nyu-York', dailyNorm: 450.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  usa_other: { id: 'usa_other', country: 'ABŞ', city: 'Digər şəhərlər (Vaşinqton daxil)', dailyNorm: 350.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // BƏƏ (Ölkə norması 280 USD; Dubay və Əbu-Dabi daxil bütün əmirliklər)
  uae: { id: 'uae', country: 'BƏƏ', city: 'Bütün əmirliklər (Dubay və Əbu-Dabi daxil)', dailyNorm: 280.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Çin (Ölkə norması 250 USD; Pekin və Şanxay daxil)
  china: { id: 'china', country: 'Çin', city: 'Bütün şəhərlər (Pekin və Şanxay daxil)', dailyNorm: 250.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Yaponiya (Ölkə norması 40,000 JPY; Tokio daxil)
  japan: { id: 'japan', country: 'Yaponiya', city: 'Bütün şəhərlər (Tokio daxil)', dailyNorm: 40000.0, currency: 'JPY', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Türkiyə (İstanbul 220 EUR, Ankara 200 EUR, Digər şəhərlər 180 EUR; İzmir üçün ayrıca norma yoxdur)
  turkey_istanbul: { id: 'turkey_istanbul', country: 'Türkiyə', city: 'İstanbul', dailyNorm: 220.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },
  turkey_ankara: { id: 'turkey_ankara', country: 'Türkiyə', city: 'Ankara', dailyNorm: 200.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },
  turkey_other: { id: 'turkey_other', country: 'Türkiyə', city: 'Digər şəhərlər (İzmir daxil)', dailyNorm: 180.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Qazaxıstan (Astana və Almatı 200 USD, Digər 160 USD)
  kazakhstan_astana_almaty: { id: 'kazakhstan_astana_almaty', country: 'Qazaxıstan', city: 'Astana və Almatı', dailyNorm: 200.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  kazakhstan_other: { id: 'kazakhstan_other', country: 'Qazaxıstan', city: 'Digər şəhərlər', dailyNorm: 160.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Özbəkistan (Daşkənd 180 USD, Digər 140 USD)
  uzbekistan_tashkent: { id: 'uzbekistan_tashkent', country: 'Özbəkistan', city: 'Daşkənd', dailyNorm: 180.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  uzbekistan_other: { id: 'uzbekistan_other', country: 'Özbəkistan', city: 'Digər şəhərlər', dailyNorm: 140.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // İtaliya (Roma və Milan 250 EUR, Digər 200 EUR)
  italy_rome_milan: { id: 'italy_rome_milan', country: 'İtaliya', city: 'Roma və Milan', dailyNorm: 250.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },
  italy_other: { id: 'italy_other', country: 'İtaliya', city: 'Digər şəhərlər', dailyNorm: 200.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Avstriya (Vyana 250 EUR, Digər 220 EUR)
  austria_vienna: { id: 'austria_vienna', country: 'Avstriya', city: 'Vyana', dailyNorm: 250.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },
  austria_other: { id: 'austria_other', country: 'Avstriya', city: 'Digər şəhərlər', dailyNorm: 220.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Belçika (Brüssel 250 EUR, Digər 220 EUR)
  belgium_brussels: { id: 'belgium_brussels', country: 'Belçika', city: 'Brüssel', dailyNorm: 250.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },
  belgium_other: { id: 'belgium_other', country: 'Belçika', city: 'Digər şəhərlər', dailyNorm: 220.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Niderland (250 EUR)
  netherlands: { id: 'netherlands', country: 'Niderland', city: 'Bütün şəhərlər (Amsterdam daxil)', dailyNorm: 250.0, currency: 'EUR', hotelPercent: 0.60, dailyPercent: 0.40 },

  // İsveçrə (Sürix və Cenevrə 350 CHF, Digər 300 CHF)
  switzerland_zurich_geneva: { id: 'switzerland_zurich_geneva', country: 'İsveçrə', city: 'Sürix və Cenevrə', dailyNorm: 350.0, currency: 'CHF', hotelPercent: 0.60, dailyPercent: 0.40 },
  switzerland_other: { id: 'switzerland_other', country: 'İsveçrə', city: 'Digər şəhərlər', dailyNorm: 300.0, currency: 'CHF', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Səudiyyə Ərəbistanı (Ər-Riyad və Ciddə 280 USD, Digər 240 USD)
  saudi_arabia: { id: 'saudi_arabia', country: 'Səudiyyə Ərəbistanı', city: 'Ər-Riyad və Ciddə', dailyNorm: 280.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Qətər (Doha 280 USD)
  qatar: { id: 'qatar', country: 'Qətər', city: 'Doha', dailyNorm: 280.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // İran (Tehran 150 USD, Digər 120 USD)
  iran_tehran: { id: 'iran_tehran', country: 'İran', city: 'Tehran', dailyNorm: 150.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  iran_other: { id: 'iran_other', country: 'İran', city: 'Digər şəhərlər', dailyNorm: 120.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Ukrayna (Kiyev 150 USD, Digər 120 USD)
  ukraine_kyiv: { id: 'ukraine_kyiv', country: 'Ukrayna', city: 'Kiyev', dailyNorm: 150.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  ukraine_other: { id: 'ukraine_other', country: 'Ukrayna', city: 'Digər şəhərlər', dailyNorm: 120.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },

  // Belarus (Minsk 150 USD, Digər 120 USD)
  belarus_minsk: { id: 'belarus_minsk', country: 'Belarus', city: 'Minsk', dailyNorm: 150.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
  belarus_other: { id: 'belarus_other', country: 'Belarus', city: 'Digər şəhərlər', dailyNorm: 120.0, currency: 'USD', hotelPercent: 0.60, dailyPercent: 0.40 },
};

// Aliases for historical / test backwards compatibility
FOREIGN_NORMS.uae_dubai = FOREIGN_NORMS.uae;
FOREIGN_NORMS.uae_dubai_abudhabi = FOREIGN_NORMS.uae;
FOREIGN_NORMS.uae_other = FOREIGN_NORMS.uae;
FOREIGN_NORMS.germany_berlin = FOREIGN_NORMS.germany;
FOREIGN_NORMS.germany_other = FOREIGN_NORMS.germany;
FOREIGN_NORMS.china_beijing_shanghai = FOREIGN_NORMS.china;
FOREIGN_NORMS.japan_tokyo = FOREIGN_NORMS.japan;
FOREIGN_NORMS.turkey_izmir = FOREIGN_NORMS.turkey_other;

/**
 * NK №14 2 nömrəli Əlavə (Rəhbər İşçilər üzrə Əlavə Faizlər)
 */
export const LEADERSHIP_CATEGORIES = {
  NO_NORMATIVE_LEADERSHIP_SUPPLEMENT: {
    id: 'NO_NORMATIVE_LEADERSHIP_SUPPLEMENT',
    label: 'Sıravi işçi / Kommersiya şirkəti əməkdaşı',
    multiplier: 1.0,
    percentAdd: 0,
    note: 'Kommersiya şirkətlərinin rəhbər heyətinə NK №14 əlavə faizləri avtomatik şamil edilmir.',
  },
  GOV_ANNEX_2_CATEGORY_1: {
    id: 'GOV_ANNEX_2_CATEGORY_1',
    label: 'Dövlət I kateqoriya (Baş nazir, MM Sədri və s.)',
    multiplier: 2.0,
    percentAdd: 100,
    note: 'NK №14 2 nömrəli əlavə: 1-ci kateqoriya dövlət vəzifəli şəxslərə 100% əlavə.',
  },
  GOV_ANNEX_2_CATEGORY_2: {
    id: 'GOV_ANNEX_2_CATEGORY_2',
    label: 'Dövlət II kateqoriya (Nazirlər, Komitə sədrləri və s.)',
    multiplier: 1.5,
    percentAdd: 50,
    note: 'NK №14 2 nömrəli əlavə: 2-ci kateqoriya dövlət vəzifəli şəxslərə 50% əlavə.',
  },
  GOV_ANNEX_2_CATEGORY_3: {
    id: 'GOV_ANNEX_2_CATEGORY_3',
    label: 'Dövlət III kateqoriya (Nazir müavinləri, rayon İH başçıları)',
    multiplier: 1.3,
    percentAdd: 30,
    note: 'NK №14 2 nömrəli əlavə: 3-cü kateqoriya dövlət vəzifəli şəxslərə 30% əlavə.',
  },
};

// Aliases
LEADERSHIP_CATEGORIES.CAT_0 = LEADERSHIP_CATEGORIES.NO_NORMATIVE_LEADERSHIP_SUPPLEMENT;
LEADERSHIP_CATEGORIES.CAT_1 = LEADERSHIP_CATEGORIES.GOV_ANNEX_2_CATEGORY_1;
LEADERSHIP_CATEGORIES.CAT_2 = LEADERSHIP_CATEGORIES.GOV_ANNEX_2_CATEGORY_2;
LEADERSHIP_CATEGORIES.CAT_3 = LEADERSHIP_CATEGORIES.GOV_ANNEX_2_CATEGORY_3;

export const LEADER_CATEGORIES = LEADERSHIP_CATEGORIES;

/**
 * Əsas Ezamiyyə Xərcləri Hesablama Mühərriki
 */
export function calculateBusinessTrip2026(input) {
  const {
    tripType = 'DOMESTIC',
    destinationKey = 'baku',
    startDate = '2026-10-01',
    endDate = '2026-10-03',
    isOneDayTrip = false,
    overnightTransport = false,
    isOvernightTransportTrip = false,
    isWeekendOrHolidayTravel = false,
    hotelDocumentStatus = 'DOCUMENTED',
    actualHotelExpensePerNight = null,
    hostProvisionStatus = 'NONE',
    leadershipCategory = 'NO_NORMATIVE_LEADERSHIP_SUPPLEMENT',
    leaderCategory = null,
    transportExpenses = 0.0,
    otherDocumentedExpenses = 0.0,
    exchangeRateToAZN = 1.0,
    paidAdvance = 0.0,
    actualPaidAllowance = null,
    averageSalaryMode = 'USER_PROVIDED_AVERAGE',
    userProvidedDailyRate = 0.0,
    monthlySalary = 1000.0,
    normalWorkingDaysInMonth = 21,
    tripWorkingDays = 0,
  } = input;

  // A. Günlərin Təyini
  const s = new Date(startDate);
  const e = new Date(endDate);
  const diffTime = Math.abs(e - s);
  const totalCalendarDays = isOneDayTrip ? 1 : Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;

  // Gecələmə günləri (Mehmanxana gecələri)
  const hasOvernightTransport = overnightTransport || isOvernightTransportTrip;
  let hotelNights = 0;
  if (!isOneDayTrip && !hasOvernightTransport && hotelDocumentStatus !== 'NOT_REQUIRED' && hotelDocumentStatus !== 'HOST_PROVIDED') {
    hotelNights = Math.max(0, totalCalendarDays - 1);
  }

  // B. Normativ Baza və Rəhbər Əlavəsi
  const isDomestic = tripType === 'DOMESTIC';
  const normData = isDomestic
    ? (DOMESTIC_NORMS[destinationKey] || DOMESTIC_NORMS.baku)
    : (FOREIGN_NORMS[destinationKey] || FOREIGN_NORMS.turkey_istanbul);

  const effectiveLeaderKey = leaderCategory || leadershipCategory;
  const leaderInfo = LEADERSHIP_CATEGORIES[effectiveLeaderKey] || LEADERSHIP_CATEGORIES.NO_NORMATIVE_LEADERSHIP_SUPPLEMENT;
  const effectiveMultiplier = leaderInfo.multiplier;

  const baseDailyNorm = normData.dailyNorm;
  const effectiveDailyNorm = Number((baseDailyNorm * effectiveMultiplier).toFixed(2));

  // Gündəlik xərc və mehmanxana norması
  const unitHotelNorm = Number((effectiveDailyNorm * normData.hotelPercent).toFixed(2));
  const unitDailyExpenseNorm = Number((effectiveDailyNorm * normData.dailyPercent).toFixed(2));

  // C. Host Təminatı Rejimləri (Q-01 Qaydaları)
  let applicableDailyExpenseRate = unitDailyExpenseNorm;
  let applicableHotelRate = unitHotelNorm;

  if (hostProvisionStatus === 'ACCOMMODATION') {
    applicableHotelRate = 0.0;
  } else if (hostProvisionStatus === 'MEALS') {
    applicableDailyExpenseRate = 0.0;
  } else if (hostProvisionStatus === 'ACCOMMODATION_AND_MEALS' || hostProvisionStatus === 'ALL_EXPENSES') {
    applicableHotelRate = 0.0;
    applicableDailyExpenseRate = 0.0;
  }

  // D. Gündəlik Xərcin Hesablanması (Per Diem)
  let totalDailyExpenses = 0.0;
  if (isOneDayTrip) {
    if (isDomestic) {
      totalDailyExpenses = applicableDailyExpenseRate; // 30% gündəlik
    } else {
      totalDailyExpenses = Number((effectiveDailyNorm * 0.40).toFixed(2)); // Q-01 xarici 40%
    }
  } else {
    totalDailyExpenses = Number((totalCalendarDays * applicableDailyExpenseRate).toFixed(2));
  }

  // E. Mehmanxana Xərcinin Hesablanması (Qanuni Kompensasiya vs Faktiki)
  let statutoryHotelExpenses = 0.0;
  let actualHotelExpensesClaimed = 0.0;
  let hotelWithoutDocumentStatus = 'NORMAL';
  let hotelAdvisoryNotice = null;

  if (isOneDayTrip || hasOvernightTransport || hotelDocumentStatus === 'NOT_REQUIRED' || hotelDocumentStatus === 'HOST_PROVIDED' || hostProvisionStatus === 'ACCOMMODATION' || hostProvisionStatus === 'ALL_EXPENSES') {
    statutoryHotelExpenses = 0.0;
    actualHotelExpensesClaimed = 0.0;
  } else if (hotelDocumentStatus === 'NOT_DOCUMENTED') {
    // Sənədsiz rejim: 50% deyil, rəsmi normativ hotel hissəsi (ölkədaxili 70%, xarici 60%) tətbiq olunur
    hotelWithoutDocumentStatus = 'STATUTORY_NORM_APPLIED';
    statutoryHotelExpenses = Number((hotelNights * applicableHotelRate).toFixed(2));
    actualHotelExpensesClaimed = statutoryHotelExpenses;
    hotelAdvisoryNotice = 'NK №14-ün 1-1-ci bəndi (keçmiş 50% sənədsiz qaydası) ləğv edilmişdir. Sənəd təqdim edilmədikdə 50% deyil, Q-01 və NK №14 üzrə müəyyən edilmiş normativ mehmanxana hissəsi (ölkədaxili 70%, xarici 60%) tətbiq olunur.';
  } else {
    // Sənədli rejim:
    const unitActual = actualHotelExpensePerNight !== null ? Number(actualHotelExpensePerNight) : applicableHotelRate;
    actualHotelExpensesClaimed = Number((hotelNights * unitActual).toFixed(2));
    statutoryHotelExpenses = Number((hotelNights * applicableHotelRate).toFixed(2));
  }

  // F. Modul A: Cəmi Qanuni Ezamiyyə Xərcləri Paketi
  const statutoryPerDiemAndLodging = Number((totalDailyExpenses + statutoryHotelExpenses).toFixed(2));
  const totalActualTripExpenses = Number((
    totalDailyExpenses +
    (hotelDocumentStatus === 'DOCUMENTED' ? actualHotelExpensesClaimed : statutoryHotelExpenses) +
    Number(transportExpenses || 0) +
    Number(otherDocumentedExpenses || 0)
  ).toFixed(2));

  // Valyuta konvertasiyası (AZN)
  const currencyRate = Number(exchangeRateToAZN) || 1.0;
  const currencyCode = normData.currency;
  const totalTripExpensesAZN = Number((totalActualTripExpenses * currencyRate).toFixed(2));
  const statutoryPerDiemAZN = Number((statutoryPerDiemAndLodging * currencyRate).toFixed(2));

  // G. Modul C: Vergi və Mənfəət Auditi (VM 98.3, 102.1.14.2, 109.7)
  const paidAmount = actualPaidAllowance !== null ? Number(actualPaidAllowance) : totalTripExpensesAZN;
  
  let taxableExcessIncomeEmployee = 0.0;
  let nonDeductibleEmployerExpense = 0.0;

  // Əgər işəgötürən sənədli faktiki xərci tam ödəyibsə:
  if (hotelDocumentStatus === 'DOCUMENTED' && actualHotelExpensesClaimed > statutoryHotelExpenses) {
    taxableExcessIncomeEmployee = 0.0;
    nonDeductibleEmployerExpense = Number(((actualHotelExpensesClaimed - statutoryHotelExpenses) * currencyRate).toFixed(2));
  }

  // Əgər işçiyə normadan artıq sənədsiz ödəniş edilibsə:
  let statutoryTaxExemptLimit = totalTripExpensesAZN;
  if (isOneDayTrip && paidAmount > totalTripExpensesAZN) {
    const fullDailyLimit = Number((effectiveDailyNorm * totalCalendarDays * currencyRate).toFixed(2));
    statutoryTaxExemptLimit = Math.max(totalTripExpensesAZN, fullDailyLimit);
  }

  if (paidAmount > statutoryTaxExemptLimit) {
    taxableExcessIncomeEmployee = Number((paidAmount - statutoryTaxExemptLimit).toFixed(2));
  }

  // H. Modul B: ƏM 179 Saxlanılan Orta Əməkhaqqı
  let estimatedDailySalary = 0.0;
  let totalPreservedSalary = 0.0;
  let averageSalaryNote = null;

  if (tripWorkingDays > 0) {
    if (averageSalaryMode === 'USER_PROVIDED_AVERAGE') {
      estimatedDailySalary = Number(userProvidedDailyRate) || 0.0;
      totalPreservedSalary = Number((tripWorkingDays * estimatedDailySalary).toFixed(2));
      averageSalaryNote = 'İstifadəçi tərəfindən daxil edilmiş faktiki orta gündəlik əməkhaqqı əsasında hesablanmışdır (ƏM m.177).';
    } else {
      const normDays = Number(normalWorkingDaysInMonth) || 21;
      estimatedDailySalary = normDays > 0 ? Number((Number(monthlySalary) / normDays).toFixed(2)) : 0.0;
      totalPreservedSalary = Number((tripWorkingDays * estimatedDailySalary).toFixed(2));
      averageSalaryNote = 'Cari vəzifə maaşı və aylıq iş günləri norması əsasında simulyasiya edilmişdir.';
    }
  }

  // I. Avans Mutabiqəti Balansı
  const advanceDifference = Number((paidAmount - totalTripExpensesAZN).toFixed(2));

  // J. Hüquqi Xəbərdarlıqlar və Qanuni Deadline-lar (Q-01 və ƏM 164)
  const returnDateObj = new Date(endDate);
  const dueObj = new Date(returnDateObj);
  dueObj.setDate(returnDateObj.getDate() + 3);
  const advanceReportDueDate = dueObj.toISOString().split('T')[0];

  const weekendHolidayNotice = isWeekendOrHolidayTravel
    ? 'Q-01 qaydalarına əsasən, rəhbərin tapşırığı ilə işçinin ezamiyyətə getdiyi və ya qayıtdığı gün istirahət və ya bayram gününə düşərsə, əmək qanunvericiliyinə (ƏM m.164) uyğun olaraq həmin günlər üçün əlavə əməkhaqqı və ya əlavə istirahət günü (əvəz) verilir.'
    : null;

  const legalNotices = {
    advanceReportDueDateRule: 'STATUTORY_3_CALENDAR_DAYS',
    advanceReportDueDate,
    advanceReportNotice: 'Q-01 qaydalarına əsasən işçi ezamiyyətdən qayıtdıqdan sonra 3 gün ərzində (' + advanceReportDueDate + ' tarixinədək) avans hesabatını mühasibata təqdim etməlidir.',
    weekendHolidayTravelStatus: isWeekendOrHolidayTravel ? 'COMPENSATION_RULE_APPLIES' : 'NORMAL',
    weekendHolidayNotice,
    taxAuthorityClarification: 'DVX rəsmi izahı (VM 98.3): Təsdiqedici sənədlərlə əsaslandırılmış faktiki ezamiyyə xərci normadan artıq olsa belə, işçinin vergiyə cəlb olunan gəlirinə aid edilmir. Sənədsiz artıq ödəmələr isə gəlir vergisi və sosial sığortaya cəlb olunur. VM 109.7-yə əsasən normadan artıq hissə işəgötürənin mənfəət vergisində gəlirdən çıxılmır.',
    hotelAdvisoryNotice,
  };

  return {
    inputs: input,
    totalCalendarDays,
    hotelNights,
    normData,
    leaderInfo,
    effectiveDailyNorm,
    unitHotelNorm,
    unitDailyExpenseNorm,
    currencyCode,
    currencyRate,
    // Modul A: Ezamiyyə Xərcləri
    totalDailyExpenses,
    statutoryHotelExpenses,
    actualHotelExpensesClaimed,
    transportExpenses: Number(transportExpenses || 0),
    otherDocumentedExpenses: Number(otherDocumentedExpenses || 0),
    statutoryPerDiemAndLodging,
    totalActualTripExpenses,
    totalTripExpensesAZN,
    statutoryPerDiemAZN,
    hotelWithoutDocumentStatus,
    // Modul B: ƏM 179 Əməkhaqqı
    modulB: {
      tripWorkingDays,
      estimatedDailySalary,
      totalPreservedSalary,
      averageSalaryMode,
      averageSalaryNote,
    },
    // Modul C: Vergi və Mənfəət Auditi
    modulC: {
      paidAmount,
      taxableExcessIncomeEmployee,
      nonDeductibleEmployerExpense,
      isFullyTaxExemptForEmployee: taxableExcessIncomeEmployee === 0.0,
    },
    // Avans Mutabiqəti
    advanceBalance: {
      paidAmount,
      actualTripCost: totalTripExpensesAZN,
      balance: advanceDifference,
      resultType: advanceDifference > 0 ? 'REFUND_TO_EMPLOYER' : advanceDifference < 0 ? 'PAYABLE_TO_EMPLOYEE' : 'EXACT_MATCH',
    },
    legalNotices,
  };
}

/**
 * 46 Test Keysi üzrə Tam Legal Regression Test Suite (TC-01 - TC-46)
 */
export function runBusinessTripCalculatorTests() {
  const testResults = [];

  const addTest = ({ id, testName, input, expected, actual, passed }) => {
    testResults.push({
      id,
      testName,
      input,
      expected,
      actual,
      status: passed ? 'PASSED' : 'FAILED',
    });
    if (!passed) {
      console.warn('FAIL:', id, '-', testName, 'Expected:', expected, 'Got:', actual);
    }
  };

  // TC-01: Ölkədaxili 1 günlük (Bakı, bilet 20 AZN)
  const tc01 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-01',
    isOneDayTrip: true,
    transportExpenses: 20.0,
  });
  addTest({
    id: 'TC-01',
    testName: 'Ölkədaxili 1 günlük ezamiyyə (Bakı)',
    input: '1 gün getdi-qayıtdı, bilet=20 AZN',
    expected: 'hotel=0, daily=37.50 AZN, transport=20 AZN, total=57.50 AZN',
    actual: 'hotel=' + tc01.statutoryHotelExpenses + ', daily=' + tc01.totalDailyExpenses + ', transport=' + tc01.transportExpenses + ', total=' + tc01.totalActualTripExpenses,
    passed: tc01.statutoryHotelExpenses === 0.0 && tc01.totalDailyExpenses === 37.50 && tc01.totalActualTripExpenses === 57.50,
  });

  // TC-02: Ölkədaxili 1 günlük (Gəncə, bilet 30 AZN)
  const tc02 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'ganja_sumgayit',
    startDate: '2026-10-01',
    endDate: '2026-10-01',
    isOneDayTrip: true,
    transportExpenses: 30.0,
  });
  addTest({
    id: 'TC-02',
    testName: 'Ölkədaxili 1 günlük ezamiyyə (Gəncə)',
    input: '1 gün getdi-qayıtdı, bilet=30 AZN',
    expected: 'hotel=0, daily=28.50 AZN, transport=30 AZN, total=58.50 AZN',
    actual: 'hotel=' + tc02.statutoryHotelExpenses + ', daily=' + tc02.totalDailyExpenses + ', transport=' + tc02.transportExpenses + ', total=' + tc02.totalActualTripExpenses,
    passed: tc02.statutoryHotelExpenses === 0.0 && tc02.totalDailyExpenses === 28.50 && tc02.totalActualTripExpenses === 58.50,
  });

  // TC-03: Bakı 4 gün (3 gecə) sənədli norma həddində
  const tc03 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 87.50,
  });
  addTest({
    id: 'TC-03',
    testName: 'Bakı 4 gün (3 gecə) sənədli norma həddində',
    input: '4 gün, 3 gecə, hotel=87.50 AZN',
    expected: 'daily=150.00 AZN (4 * 37.50), hotel=262.50 AZN (3 * 87.50), total=412.50 AZN',
    actual: 'daily=' + tc03.totalDailyExpenses + ', hotel=' + tc03.statutoryHotelExpenses + ', total=' + tc03.totalActualTripExpenses,
    passed: tc03.totalDailyExpenses === 150.00 && tc03.statutoryHotelExpenses === 262.50 && tc03.totalActualTripExpenses === 412.50,
  });

  // TC-04: Bakı 4 gün SƏNƏDSİZ (70% normativ hotel tətbiq olunur)
  const tc04 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'NOT_DOCUMENTED',
  });
  addTest({
    id: 'TC-04',
    testName: 'Bakı 4 gün sənədsiz (70% normativ hotel verilir)',
    input: '4 gün, 3 gecə, sənədsiz',
    expected: 'daily=150.00, hotel=262.50 AZN (3 * 87.50), total=412.50 AZN, status=STATUTORY_NORM_APPLIED',
    actual: 'daily=' + tc04.totalDailyExpenses + ', hotel=' + tc04.statutoryHotelExpenses + ', total=' + tc04.totalActualTripExpenses + ', status=' + tc04.hotelWithoutDocumentStatus,
    passed: tc04.totalDailyExpenses === 150.00 && tc04.statutoryHotelExpenses === 262.50 && tc04.totalActualTripExpenses === 412.50 && tc04.hotelWithoutDocumentStatus === 'STATUTORY_NORM_APPLIED',
  });

  // TC-05: Bakı hotel normadan ucuz sənədlə (60 < 87.50)
  const tc05 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 2 gecə
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 60.0,
  });
  addTest({
    id: 'TC-05',
    testName: 'Bakı hotel normadan ucuz sənədlə',
    input: '2 gecə @ 60 AZN (norma 87.50)',
    expected: 'actualHotelClaimed=120.00 AZN ödənilir',
    actual: 'actualHotelClaimed=' + tc05.actualHotelExpensesClaimed,
    passed: tc05.actualHotelExpensesClaimed === 120.00,
  });

  // TC-06: Bakı hotel normadan baha sənədlə (VM 98.3 vs VM 109.7)
  const tc06 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 2 gecə
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 150.0, // 150 > 87.50
  });
  addTest({
    id: 'TC-06',
    testName: 'Bakı hotel normadan baha sənədlə (VM 98.3 vs VM 109.7)',
    input: '2 gecə @ 150 AZN sənədli (norma 87.50)',
    expected: 'taxableExcessIncomeEmployee=0, nonDeductibleEmployerExpense=125.00 AZN (2 * 62.50)',
    actual: 'empTaxable=' + tc06.modulC.taxableExcessIncomeEmployee + ', nonDeductible=' + tc06.modulC.nonDeductibleEmployerExpense,
    passed: tc06.modulC.taxableExcessIncomeEmployee === 0.0 && tc06.modulC.nonDeductibleEmployerExpense === 125.00,
  });

  // TC-07: Normadan artıq sənədsiz 1 günlük ödəniş (200 - 125 = 75 AZN excess)
  const tc07 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-01',
    isOneDayTrip: true,
    actualPaidAllowance: 200.0, // Norma: 125 AZN
  });
  addTest({
    id: 'TC-07',
    testName: '1 günlük normadan artıq ödəniş (200 - 125 = 75 AZN excess)',
    input: '1 gün Bakı, ödənilmiş=200 AZN, norma=125 AZN',
    expected: 'taxableExcessIncomeEmployee=75.00 AZN (200 - 125)',
    actual: 'taxableExcess=' + tc07.modulC.taxableExcessIncomeEmployee,
    passed: tc07.modulC.taxableExcessIncomeEmployee === 75.00,
  });

  // TC-08: Naxçıvan şəhəri (Sənədli norma 100 AZN)
  const tc08 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'nakhchivan',
    startDate: '2026-10-01',
    endDate: '2026-10-04', // 4 gün (3 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 70.0,
  });
  addTest({
    id: 'TC-08',
    testName: 'Naxçıvan şəhəri (Sənədli norma 100 AZN)',
    input: '4 gün (3 gecə), sənədli',
    expected: 'daily=120.00 (4 * 30), hotel=210.00 (3 * 70), total=330.00 AZN',
    actual: 'daily=' + tc08.totalDailyExpenses + ', hotel=' + tc08.statutoryHotelExpenses + ', total=' + tc08.totalActualTripExpenses,
    passed: tc08.totalDailyExpenses === 120.00 && tc08.statutoryHotelExpenses === 210.00 && tc08.totalActualTripExpenses === 330.00,
  });

  // TC-09: Naxçıvan şəhəri (Sənədsiz -> 70% normativ hotel = 210 AZN)
  const tc09 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'nakhchivan',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'NOT_DOCUMENTED',
  });
  addTest({
    id: 'TC-09',
    testName: 'Naxçıvan şəhəri (Sənədsiz — 70% norma tətbiq olunur)',
    input: '4 gün, 3 gecə, sənədsiz',
    expected: 'daily=120.00, hotel=210.00 AZN, total=330.00 AZN',
    actual: 'hotel=' + tc09.statutoryHotelExpenses + ', total=' + tc09.totalActualTripExpenses,
    passed: tc09.statutoryHotelExpenses === 210.00 && tc09.totalDailyExpenses === 120.00 && tc09.totalActualTripExpenses === 330.00,
  });

  // TC-10: Gəncə / Sumqayıt (Sənədli norma 95 AZN)
  const tc10 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'ganja_sumgayit',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 66.50,
  });
  addTest({
    id: 'TC-10',
    testName: 'Gəncə və Sumqayıt şəhərləri (Norma 95 AZN)',
    input: '3 gün (2 gecə), sənədli',
    expected: 'daily=85.50 (3 * 28.50), hotel=133.00 (2 * 66.50)',
    actual: 'daily=' + tc10.totalDailyExpenses + ', hotel=' + tc10.statutoryHotelExpenses,
    passed: tc10.totalDailyExpenses === 85.50 && tc10.statutoryHotelExpenses === 133.00,
  });

  // TC-11: Digər rayonlar (Norma 90 AZN, 3 gün 2 gecə)
  const tc11 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'other_regions',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 63.0,
  });
  addTest({
    id: 'TC-11',
    testName: 'Digər şəhər və rayonlar (Norma 90 AZN)',
    input: '3 gün (2 gecə), sənədli',
    expected: 'daily=81.00 (3 * 27.00), hotel=126.00 (2 * 63.00)',
    actual: 'daily=' + tc11.totalDailyExpenses + ', hotel=' + tc11.statutoryHotelExpenses,
    passed: tc11.totalDailyExpenses === 81.00 && tc11.statutoryHotelExpenses === 126.00,
  });

  // TC-12: Nəqliyyatda gecələmə / Gecə qatarı (Patch 1: hotelNights=0, gündəlik qalır)
  const tc12 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'other_regions',
    startDate: '2026-10-01',
    endDate: '2026-10-02', // 2 təqvim günü
    isOvernightTransportTrip: true,
  });
  addTest({
    id: 'TC-12',
    testName: 'Nəqliyyatda gecələmə / gecə qatarı (Patch 1: hotel=0, gündəlik 2 gün)',
    input: '2 təqvim günü, overnightTransport=true',
    expected: 'hotelNights=0, hotel=0 AZN, daily=54.00 AZN (2 * 27.00)',
    actual: 'hotelNights=' + tc12.hotelNights + ', hotel=' + tc12.statutoryHotelExpenses + ', daily=' + tc12.totalDailyExpenses,
    passed: tc12.hotelNights === 0 && tc12.statutoryHotelExpenses === 0.0 && tc12.totalDailyExpenses === 54.00,
  });

  // TC-13: Qəbul edən tərəf yaşayışı təmin edir (ACCOMMODATION)
  const tc13 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün
    hostProvisionStatus: 'ACCOMMODATION',
  });
  addTest({
    id: 'TC-13',
    testName: 'Qəbul edən tərəf yaşayışı təmin edir (ACCOMMODATION)',
    input: 'hostProvision=ACCOMMODATION, 3 gün',
    expected: 'hotel=0 AZN, daily=112.50 AZN',
    actual: 'hotel=' + tc13.statutoryHotelExpenses + ', daily=' + tc13.totalDailyExpenses,
    passed: tc13.statutoryHotelExpenses === 0.0 && tc13.totalDailyExpenses === 112.50,
  });

  // TC-14: Qəbul edən tərəf yaşayış və yeməyi təmin edir
  const tc14 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün
    hostProvisionStatus: 'ACCOMMODATION_AND_MEALS',
    transportExpenses: 50.0,
  });
  addTest({
    id: 'TC-14',
    testName: 'Qəbul edən tərəf yaşayış və yeməyi təmin edir',
    input: 'hostProvision=ACCOMMODATION_AND_MEALS, bilet=50',
    expected: 'hotel=0, daily=0, totalActual=50 AZN (yalnız nəqliyyat)',
    actual: 'hotel=' + tc14.statutoryHotelExpenses + ', daily=' + tc14.totalDailyExpenses + ', total=' + tc14.totalActualTripExpenses,
    passed: tc14.statutoryHotelExpenses === 0.0 && tc14.totalDailyExpenses === 0.0 && tc14.totalActualTripExpenses === 50.00,
  });

  // TC-15: Xarici 1 günlük ezamiyyə (Tbilisi rəsmi norma 200 USD!)
  const tc15 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'georgia_tbilisi',
    startDate: '2026-10-01',
    endDate: '2026-10-01',
    isOneDayTrip: true,
  });
  addTest({
    id: 'TC-15',
    testName: 'Xarici 1 günlük ezamiyyə (Tbilisi 200 USD norma)',
    input: '1 gün Tbilisi, norma=200 USD',
    expected: 'hotel=0 USD, daily=80.00 USD (40% of 200)',
    actual: 'hotel=' + tc15.statutoryHotelExpenses + ', daily=' + tc15.totalDailyExpenses + ' ' + tc15.currencyCode,
    passed: tc15.statutoryHotelExpenses === 0.0 && tc15.totalDailyExpenses === 80.00,
  });

  // TC-16: Xarici ezamiyyə — Gürcüstan digər şəhərlər (Rəsmi norma 155 USD, 3 gün 2 gecə)
  const tc16 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'georgia_other',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 93.0,
  });
  addTest({
    id: 'TC-16',
    testName: 'Xarici ezamiyyə — Gürcüstan digər şəhərlər (Norma 155 USD)',
    input: '3 gün (2 gecə), norma=155 USD',
    expected: 'daily=186.00 USD (3 * 62), hotel=186.00 USD (2 * 93), total=372.00 USD',
    actual: 'daily=' + tc16.totalDailyExpenses + ', hotel=' + tc16.statutoryHotelExpenses + ', total=' + tc16.totalActualTripExpenses,
    passed: tc16.totalDailyExpenses === 186.00 && tc16.statutoryHotelExpenses === 186.00 && tc16.totalActualTripExpenses === 372.00,
  });

  // TC-17: Xarici ezamiyyə — Türkiyə / İstanbul (220 EUR, 4 gün 3 gecə)
  const tc17 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'turkey_istanbul',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 132.0,
  });
  addTest({
    id: 'TC-17',
    testName: 'Xarici ezamiyyə — Türkiyə / İstanbul (220 EUR)',
    input: '4 gün (3 gecə), sənədli norma həddində',
    expected: 'daily=352.00 EUR (4 * 88), hotel=396.00 EUR (3 * 132), total=748.00 EUR',
    actual: 'daily=' + tc17.totalDailyExpenses + ', hotel=' + tc17.statutoryHotelExpenses + ', total=' + tc17.totalActualTripExpenses,
    passed: tc17.totalDailyExpenses === 352.00 && tc17.statutoryHotelExpenses === 396.00 && tc17.totalActualTripExpenses === 748.00,
  });

  // TC-18: Xarici ezamiyyə — Türkiyə / Ankara (200 EUR, 4 gün 3 gecə)
  const tc18 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'turkey_ankara',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 120.0,
  });
  addTest({
    id: 'TC-18',
    testName: 'Xarici ezamiyyə — Türkiyə / Ankara (200 EUR)',
    input: '4 gün (3 gecə), sənədli',
    expected: 'daily=320.00 EUR (4 * 80), hotel=360.00 EUR (3 * 120), total=680.00 EUR',
    actual: 'daily=' + tc18.totalDailyExpenses + ', hotel=' + tc18.statutoryHotelExpenses + ', total=' + tc18.totalActualTripExpenses,
    passed: tc18.totalDailyExpenses === 320.00 && tc18.statutoryHotelExpenses === 360.00 && tc18.totalActualTripExpenses === 680.00,
  });

  // TC-19: Xarici ezamiyyə — Böyük Britaniya / London (Rəsmi norma 280 GBP!)
  const tc19 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uk_london',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 168.0,
  });
  addTest({
    id: 'TC-19',
    testName: 'Xarici ezamiyyə — Böyük Britaniya / London (Norma 280 GBP)',
    input: '3 gün (2 gecə), London norma=280 GBP',
    expected: 'daily=336.00 GBP (3 * 112), hotel=336.00 GBP (2 * 168), total=672.00 GBP',
    actual: 'daily=' + tc19.totalDailyExpenses + ', hotel=' + tc19.statutoryHotelExpenses + ', total=' + tc19.totalActualTripExpenses,
    passed: tc19.totalDailyExpenses === 336.00 && tc19.statutoryHotelExpenses === 336.00 && tc19.totalActualTripExpenses === 672.00,
  });

  // TC-20: Xarici ezamiyyə — Böyük Britaniya digər şəhərlər (Norma 250 GBP)
  const tc20 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uk_other',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 150.0,
  });
  addTest({
    id: 'TC-20',
    testName: 'Xarici ezamiyyə — Böyük Britaniya digər şəhərlər (Norma 250 GBP)',
    input: '3 gün (2 gecə), norma=250 GBP',
    expected: 'daily=300.00 GBP (3 * 100), hotel=300.00 GBP (2 * 150), total=600.00 GBP',
    actual: 'daily=' + tc20.totalDailyExpenses + ', hotel=' + tc20.statutoryHotelExpenses + ', total=' + tc20.totalActualTripExpenses,
    passed: tc20.totalDailyExpenses === 300.00 && tc20.statutoryHotelExpenses === 300.00 && tc20.totalActualTripExpenses === 600.00,
  });

  // TC-21: Xarici ezamiyyə — Rusiya / Moskva (260 USD, 4 gün 3 gecə)
  const tc21 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'russia_moscow',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 156.0,
  });
  addTest({
    id: 'TC-21',
    testName: 'Xarici ezamiyyə — Rusiya / Moskva (260 USD)',
    input: '4 gün (3 gecə), norma=260 USD',
    expected: 'daily=416.00 USD (4 * 104), hotel=468.00 USD (3 * 156), total=884.00 USD',
    actual: 'daily=' + tc21.totalDailyExpenses + ', hotel=' + tc21.statutoryHotelExpenses + ', total=' + tc21.totalActualTripExpenses,
    passed: tc21.totalDailyExpenses === 416.00 && tc21.statutoryHotelExpenses === 468.00 && tc21.totalActualTripExpenses === 884.00,
  });

  // TC-22: Xarici ezamiyyə — BƏƏ (280 USD ölkə norması, 4 gün 3 gecə)
  const tc22 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uae',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 168.0,
  });
  addTest({
    id: 'TC-22',
    testName: 'Xarici ezamiyyə — BƏƏ (280 USD)',
    input: '4 gün (3 gecə), norma=280 USD',
    expected: 'daily=448.00 USD (4 * 112), hotel=504.00 USD (3 * 168), total=952.00 USD',
    actual: 'daily=' + tc22.totalDailyExpenses + ', hotel=' + tc22.statutoryHotelExpenses + ', total=' + tc22.totalActualTripExpenses,
    passed: tc22.totalDailyExpenses === 448.00 && tc22.statutoryHotelExpenses === 504.00 && tc22.totalActualTripExpenses === 952.00,
  });

  // TC-23: Rəhbər heyət 1-ci dərəcə (+100%, 250 AZN/gün, 3 gün)
  const tc23 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    leadershipCategory: 'GOV_ANNEX_2_CATEGORY_1',
  });
  addTest({
    id: 'TC-23',
    testName: 'Rəhbər heyət 1-ci dərəcə (+100% əlavə, 250 AZN/gün)',
    input: 'Bakı 3 gün, 1-ci kateqoriya',
    expected: 'effectiveNorm=250.00 AZN, daily=225.00 AZN (3 * 75.00)',
    actual: 'effectiveNorm=' + tc23.effectiveDailyNorm + ', daily=' + tc23.totalDailyExpenses,
    passed: tc23.effectiveDailyNorm === 250.00 && tc23.totalDailyExpenses === 225.00,
  });

  // TC-24: Rəhbər heyət 2-ci dərəcə (+50%, 187.50 AZN/gün, 3 gün)
  const tc24 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    leadershipCategory: 'GOV_ANNEX_2_CATEGORY_2',
  });
  addTest({
    id: 'TC-24',
    testName: 'Rəhbər heyət 2-ci dərəcə (+50% əlavə, 187.50 AZN/gün)',
    input: 'Bakı 3 gün, 2-ci kateqoriya',
    expected: 'effectiveNorm=187.50 AZN, daily=168.75 AZN (3 * 56.25)',
    actual: 'effectiveNorm=' + tc24.effectiveDailyNorm + ', daily=' + tc24.totalDailyExpenses,
    passed: tc24.effectiveDailyNorm === 187.50 && tc24.totalDailyExpenses === 168.75,
  });

  // TC-25: Rəhbər heyət 3-cü dərəcə (+30%, 162.50 AZN/gün, 3 gün)
  const tc25 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    leadershipCategory: 'GOV_ANNEX_2_CATEGORY_3',
  });
  addTest({
    id: 'TC-25',
    testName: 'Rəhbər heyət 3-cü dərəcə (+30% əlavə, 162.50 AZN/gün)',
    input: 'Bakı 3 gün, 3-cü kateqoriya',
    expected: 'effectiveNorm=162.50 AZN, daily=146.25 AZN (3 * 48.75)',
    actual: 'effectiveNorm=' + tc25.effectiveDailyNorm + ', daily=' + tc25.totalDailyExpenses,
    passed: tc25.effectiveDailyNorm === 162.50 && tc25.totalDailyExpenses === 146.25,
  });

  // TC-26: Kommersiya rəhbəri (Standart işçi rejimi, 125 AZN/gün)
  const tc26 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    leadershipCategory: 'NO_NORMATIVE_LEADERSHIP_SUPPLEMENT',
  });
  addTest({
    id: 'TC-26',
    testName: 'Kommersiya rəhbəri (Standart norma, əlavə faiz şamil edilmir)',
    input: 'Bakı 3 gün, Kommersiya şirkəti',
    expected: 'effectiveNorm=125.00 AZN, daily=112.50 AZN',
    actual: 'effectiveNorm=' + tc26.effectiveDailyNorm + ', daily=' + tc26.totalDailyExpenses,
    passed: tc26.effectiveDailyNorm === 125.00 && tc26.totalDailyExpenses === 112.50,
  });

  // TC-27: Xarici ezamiyyə sənədsiz mehmanxana (BƏƏ 280 USD -> 60% normativ hotel = 504 USD)
  const tc27 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uae',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'NOT_DOCUMENTED',
  });
  addTest({
    id: 'TC-27',
    testName: 'Xarici ezamiyyə sənədsiz mehmanxana (60% normativ hotel tətbiq olunur)',
    input: 'BƏƏ 4 gün (3 gecə), sənədsiz',
    expected: 'daily=448.00 USD, hotel=504.00 USD (3 * 168), total=952.00 USD',
    actual: 'hotel=' + tc27.statutoryHotelExpenses + ', daily=' + tc27.totalDailyExpenses + ', total=' + tc27.totalActualTripExpenses,
    passed: tc27.statutoryHotelExpenses === 504.00 && tc27.totalDailyExpenses === 448.00 && tc27.totalActualTripExpenses === 952.00,
  });

  // TC-28: Xarici ezamiyyə qəbul edən tərəf yaşayışı təmin edir
  const tc28 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uae',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hostProvisionStatus: 'ACCOMMODATION',
  });
  addTest({
    id: 'TC-28',
    testName: 'Xarici ezamiyyə qəbul edən tərəf yaşayışı təmin edir',
    input: 'BƏƏ 4 gün, hostProvision=ACCOMMODATION',
    expected: 'hotel=0 USD, daily=448.00 USD',
    actual: 'hotel=' + tc28.statutoryHotelExpenses + ', daily=' + tc28.totalDailyExpenses,
    passed: tc28.statutoryHotelExpenses === 0.0 && tc28.totalDailyExpenses === 448.00,
  });

  // TC-29: Xarici ezamiyyə qəbul edən tərəf yeməyi təmin edir
  const tc29 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uae',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hostProvisionStatus: 'MEALS',
  });
  addTest({
    id: 'TC-29',
    testName: 'Xarici ezamiyyə qəbul edən tərəf yeməyi təmin edir',
    input: 'BƏƏ 4 gün (3 gecə), hostProvision=MEALS',
    expected: 'daily=0 USD, hotel=504.00 USD (60%)',
    actual: 'daily=' + tc29.totalDailyExpenses + ', hotel=' + tc29.statutoryHotelExpenses,
    passed: tc29.totalDailyExpenses === 0.0 && tc29.statutoryHotelExpenses === 504.00,
  });

  // TC-30: Xarici ezamiyyə bütün xərclər qarşılanır
  const tc30 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uae',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hostProvisionStatus: 'ALL_EXPENSES',
  });
  addTest({
    id: 'TC-30',
    testName: 'Xarici ezamiyyə bütün xərclər qəbul edən tərəfindən qarşılanır',
    input: 'hostProvision=ALL_EXPENSES',
    expected: 'hotel=0, daily=0, totalActual=0 USD',
    actual: 'hotel=' + tc30.statutoryHotelExpenses + ', daily=' + tc30.totalDailyExpenses + ', total=' + tc30.totalActualTripExpenses,
    passed: tc30.statutoryHotelExpenses === 0.0 && tc30.totalDailyExpenses === 0.0 && tc30.totalActualTripExpenses === 0.0,
  });

  // TC-31: Avans hesabatının təqdim edilmə müddəti (Q-01 üzrə qayıtdıqdan sonra 3 təqvim günü!)
  const tc31 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
  });
  addTest({
    id: 'TC-31',
    testName: 'Avans hesabatı təqdimat müddəti (Q-01: Qayıtdıqdan sonra 3 təqvim günü)',
    input: 'endDate=2026-10-04',
    expected: 'advanceReportDueDate = 2026-10-07, rule = STATUTORY_3_CALENDAR_DAYS',
    actual: 'dueDate=' + tc31.legalNotices.advanceReportDueDate + ', rule=' + tc31.legalNotices.advanceReportDueDateRule,
    passed: tc31.legalNotices.advanceReportDueDate === '2026-10-07' && tc31.legalNotices.advanceReportDueDateRule === 'STATUTORY_3_CALENDAR_DAYS',
  });

  // TC-32: İstirahət/bayram günündə səfər (Q-01 & ƏM 164 kompensasiya qaydası)
  const tc32 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-03',
    endDate: '2026-10-04',
    isWeekendOrHolidayTravel: true,
  });
  addTest({
    id: 'TC-32',
    testName: 'İstirahət / bayram günündə ezamiyyətə çıxma (COMPENSATION_RULE_APPLIES)',
    input: 'isWeekendOrHolidayTravel=true',
    expected: 'weekendHolidayTravelStatus = COMPENSATION_RULE_APPLIES (əvəz günü və ya əlavə ödəniş hüququ)',
    actual: 'status=' + tc32.legalNotices.weekendHolidayTravelStatus,
    passed: tc32.legalNotices.weekendHolidayTravelStatus === 'COMPENSATION_RULE_APPLIES' && !!tc32.legalNotices.weekendHolidayNotice,
  });

  // TC-33: Xarici ezamiyyə valyuta konvertasiyası (London 672 GBP @ 2.15)
  const tc33 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'uk_london',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    exchangeRateToAZN: 2.15,
  });
  addTest({
    id: 'TC-33',
    testName: 'Valyuta konvertasiyası (London 672 GBP @ 2.15)',
    input: '672 GBP @ 2.15 AZN',
    expected: 'totalAZN = 1444.80 AZN (672 * 2.15)',
    actual: 'totalAZN=' + tc33.totalTripExpensesAZN,
    passed: tc33.totalTripExpensesAZN === 1444.80,
  });

  // TC-34: Avans qalığı mutabiqəti (500 ödənilmiş, xərc 412.50)
  const tc34 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    actualPaidAllowance: 500.0,
  });
  addTest({
    id: 'TC-34',
    testName: 'Avans qalığı mutabiqəti (Artıq ödəmə)',
    input: 'ödənilmiş=500 AZN, xərc=412.50 AZN',
    expected: 'balance = 87.50 AZN, type = REFUND_TO_EMPLOYER',
    actual: 'balance=' + tc34.advanceBalance.balance + ', type=' + tc34.advanceBalance.resultType,
    passed: tc34.advanceBalance.balance === 87.50 && tc34.advanceBalance.resultType === 'REFUND_TO_EMPLOYER',
  });

  // TC-35: Avans kəsri mutabiqəti (300 ödənilmiş, xərc 412.50)
  const tc35 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    actualPaidAllowance: 300.0,
  });
  addTest({
    id: 'TC-35',
    testName: 'Avans kəsri mutabiqəti (Əskik ödəmə)',
    input: 'ödənilmiş=300 AZN, xərc=412.50 AZN',
    expected: 'balance = -112.50 AZN, type = PAYABLE_TO_EMPLOYEE',
    actual: 'balance=' + tc35.advanceBalance.balance + ', type=' + tc35.advanceBalance.resultType,
    passed: tc35.advanceBalance.balance === -112.50 && tc35.advanceBalance.resultType === 'PAYABLE_TO_EMPLOYEE',
  });

  // TC-36: ƏM 179 Saxlanılan əməkhaqqı (Faktiki rejim, 3 gün @ 50 AZN)
  const tc36 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    tripWorkingDays: 3,
    averageSalaryMode: 'USER_PROVIDED_AVERAGE',
    userProvidedDailyRate: 50.0,
  });
  addTest({
    id: 'TC-36',
    testName: 'ƏM 179 Saxlanılan əməkhaqqı (Faktiki orta günlük rejim)',
    input: 'tripWorkingDays=3, userProvidedDailyRate=50.00',
    expected: 'estimatedDailySalary=50.00, totalPreservedSalary=150.00 AZN',
    actual: 'dailyRate=' + tc36.modulB.estimatedDailySalary + ', totalPreserved=' + tc36.modulB.totalPreservedSalary,
    passed: tc36.modulB.estimatedDailySalary === 50.00 && tc36.modulB.totalPreservedSalary === 150.00,
  });

  // TC-37: ƏM 179 Saxlanılan əməkhaqqı (Vəzifə maaşı 1200 / 21 = 57.14 AZN, 3 gün)
  const tc37 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    tripWorkingDays: 3,
    averageSalaryMode: 'LEGAL_AVERAGE_CALCULATION',
    monthlySalary: 1200.0,
    normalWorkingDaysInMonth: 21,
  });
  addTest({
    id: 'TC-37',
    testName: 'ƏM 179 Saxlanılan əməkhaqqı (Vəzifə maaşı simulyasiyası)',
    input: 'tripWorkingDays=3, monthlySalary=1200, normDays=21',
    expected: 'estimatedDailySalary=57.14, totalPreservedSalary=171.42 AZN',
    actual: 'dailyRate=' + tc37.modulB.estimatedDailySalary + ', totalPreserved=' + tc37.modulB.totalPreservedSalary,
    passed: tc37.modulB.estimatedDailySalary === 57.14 && tc37.modulB.totalPreservedSalary === 171.42,
  });

  // TC-38: Digər rayonlar sənədsiz (Norma 90 AZN, 3 gün 2 gecə)
  const tc38 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'other_regions',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    hotelDocumentStatus: 'NOT_DOCUMENTED',
  });
  addTest({
    id: 'TC-38',
    testName: 'Digər rayonlar sənədsiz (Norma 90 AZN, 70% hotel = 126 AZN)',
    input: '3 gün (2 gecə) sənədsiz',
    expected: 'daily=81.00 (3 * 27), statutoryHotel=126.00 (2 * 63), total=207.00 AZN',
    actual: 'daily=' + tc38.totalDailyExpenses + ', hotel=' + tc38.statutoryHotelExpenses + ', total=' + tc38.totalActualTripExpenses,
    passed: tc38.totalDailyExpenses === 81.00 && tc38.statutoryHotelExpenses === 126.00 && tc38.totalActualTripExpenses === 207.00,
  });

  // TC-39: Gürcüstan digər şəhərlər (Batumi daxil, rəsmi norma 155 USD, 3 gün 2 gecə)
  const tc39 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'georgia_other',
    startDate: '2026-10-01',
    endDate: '2026-10-03',
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 93.0,
  });
  addTest({
    id: 'TC-39',
    testName: 'Gürcüstan digər şəhərlər (Batumi daxil — Rəsmi norma 155 USD)',
    input: '3 gün (2 gecə), norma=155 USD',
    expected: 'daily=186.00 USD (3 * 62), hotel=186.00 USD (2 * 93), total=372.00 USD',
    actual: 'daily=' + tc39.totalDailyExpenses + ', hotel=' + tc39.statutoryHotelExpenses + ', total=' + tc39.totalActualTripExpenses,
    passed: tc39.totalDailyExpenses === 186.00 && tc39.statutoryHotelExpenses === 186.00 && tc39.totalActualTripExpenses === 372.00,
  });

  // TC-40: Çoxgünlük sənədsiz artıq ödəmə (Bakı 4 gün 3 gecə norma 412.50 AZN, ödənilmiş 600 AZN)
  const tc40 = calculateBusinessTrip2026({
    tripType: 'DOMESTIC',
    destinationKey: 'baku',
    startDate: '2026-10-01',
    endDate: '2026-10-04',
    hotelDocumentStatus: 'NOT_DOCUMENTED',
    actualPaidAllowance: 600.0,
  });
  addTest({
    id: 'TC-40',
    testName: 'Çoxgünlük sənədsiz artıq ödəmə (600 AZN vs 412.50 AZN norma)',
    input: 'ödənilmiş=600 AZN, norma=412.50 AZN',
    expected: 'taxableExcessIncomeEmployee=187.50 AZN (600 - 412.50)',
    actual: 'taxableExcess=' + tc40.modulC.taxableExcessIncomeEmployee,
    passed: tc40.modulC.taxableExcessIncomeEmployee === 187.50,
  });

  // TC-41: Rusiya / Sankt-Peterburq (Rəsmi norma 260 USD — Moskva ilə eyni dərəcə)
  const tc41 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'russia_spb',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 156.0,
  });
  addTest({
    id: 'TC-41',
    testName: 'Rusiya / Sankt-Peterburq (Rəsmi norma 260 USD)',
    input: '3 gün (2 gecə), norma=260 USD',
    expected: 'daily=312.00 USD (3 * 104), hotel=312.00 USD (2 * 156), total=624.00 USD',
    actual: 'daily=' + tc41.totalDailyExpenses + ', hotel=' + tc41.statutoryHotelExpenses + ', total=' + tc41.totalActualTripExpenses,
    passed: tc41.totalDailyExpenses === 312.00 && tc41.statutoryHotelExpenses === 312.00 && tc41.totalActualTripExpenses === 624.00,
  });

  // TC-42: Fransa / Paris (Rəsmi norma 300 EUR!)
  const tc42 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'france_paris',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 180.0,
  });
  addTest({
    id: 'TC-42',
    testName: 'Fransa / Paris (Rəsmi norma 300 EUR)',
    input: '3 gün (2 gecə), Paris norma=300 EUR',
    expected: 'daily=360.00 EUR (3 * 120), hotel=360.00 EUR (2 * 180), total=720.00 EUR',
    actual: 'daily=' + tc42.totalDailyExpenses + ', hotel=' + tc42.statutoryHotelExpenses + ', total=' + tc42.totalActualTripExpenses,
    passed: tc42.totalDailyExpenses === 360.00 && tc42.statutoryHotelExpenses === 360.00 && tc42.totalActualTripExpenses === 720.00,
  });

  // TC-43: Almaniya (Rəsmi ölkə norması 250 EUR — Bütün şəhərlər üçün vahid norma)
  const tc43 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'germany',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 150.0,
  });
  addTest({
    id: 'TC-43',
    testName: 'Almaniya (Rəsmi vahid ölkə norması 250 EUR)',
    input: '3 gün (2 gecə), Berlin/Frankfurt/Münhen daxil norma=250 EUR',
    expected: 'daily=300.00 EUR (3 * 100), hotel=300.00 EUR (2 * 150), total=600.00 EUR',
    actual: 'daily=' + tc43.totalDailyExpenses + ', hotel=' + tc43.statutoryHotelExpenses + ', total=' + tc43.totalActualTripExpenses,
    passed: tc43.totalDailyExpenses === 300.00 && tc43.statutoryHotelExpenses === 300.00 && tc43.totalActualTripExpenses === 600.00,
  });

  // TC-44: ABŞ digər şəhərlər (Vaşinqton daxil, rəsmi norma 350 USD)
  const tc44 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'usa_other',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 210.0,
  });
  addTest({
    id: 'TC-44',
    testName: 'ABŞ digər şəhərlər (Vaşinqton daxil — Rəsmi norma 350 USD)',
    input: '3 gün (2 gecə), Vaşinqton daxil norma=350 USD',
    expected: 'daily=420.00 USD (3 * 140), hotel=420.00 USD (2 * 210), total=840.00 USD',
    actual: 'daily=' + tc44.totalDailyExpenses + ', hotel=' + tc44.statutoryHotelExpenses + ', total=' + tc44.totalActualTripExpenses,
    passed: tc44.totalDailyExpenses === 420.00 && tc44.statutoryHotelExpenses === 420.00 && tc44.totalActualTripExpenses === 840.00,
  });

  // TC-45: Çin (Rəsmi ölkə norması 250 USD)
  const tc45 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'china',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 150.0,
  });
  addTest({
    id: 'TC-45',
    testName: 'Çin (Rəsmi vahid ölkə norması 250 USD)',
    input: '3 gün (2 gecə), Pekin və Şanxay daxil norma=250 USD',
    expected: 'daily=300.00 USD (3 * 100), hotel=300.00 USD (2 * 150), total=600.00 USD',
    actual: 'daily=' + tc45.totalDailyExpenses + ', hotel=' + tc45.statutoryHotelExpenses + ', total=' + tc45.totalActualTripExpenses,
    passed: tc45.totalDailyExpenses === 300.00 && tc45.statutoryHotelExpenses === 300.00 && tc45.totalActualTripExpenses === 600.00,
  });

  // TC-46: Yaponiya (Rəsmi ölkə norması 40,000 JPY!)
  const tc46 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'japan',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 24000.0,
  });
  addTest({
    id: 'TC-46',
    testName: 'Yaponiya (Rəsmi vahid ölkə norması 40,000 JPY)',
    input: '3 gün (2 gecə), Tokio daxil norma=40,000 JPY',
    expected: 'daily=48000.00 JPY (3 * 16000), hotel=48000.00 JPY (2 * 24000), total=96000.00 JPY',
    actual: 'daily=' + tc46.totalDailyExpenses + ', hotel=' + tc46.statutoryHotelExpenses + ', total=' + tc46.totalActualTripExpenses,
    passed: tc46.totalDailyExpenses === 48000.00 && tc46.statutoryHotelExpenses === 48000.00 && tc46.totalActualTripExpenses === 96000.00,
  });

  // TC-47: Türkiyə / İzmir (Cari NK №14: İzmir üçün ayrıca norma yoxdur, ölkə norması 180 EUR tətbiq edilir)
  const tc47 = calculateBusinessTrip2026({
    tripType: 'FOREIGN',
    destinationKey: 'turkey_other',
    startDate: '2026-10-01',
    endDate: '2026-10-03', // 3 gün (2 gecə)
    hotelDocumentStatus: 'DOCUMENTED',
    actualHotelExpensePerNight: 108.0,
  });
  addTest({
    id: 'TC-47',
    testName: 'Türkiyə / İzmir (Ölkə norması 180 EUR tətbiq olunur)',
    input: '3 gün (2 gecə), İzmir norma=180 EUR (40% gündəlik=72 EUR, 60% mehmanxana=108 EUR)',
    expected: 'daily=216.00 EUR (3 * 72), hotel=216.00 EUR (2 * 108), total=432.00 EUR',
    actual: 'daily=' + tc47.totalDailyExpenses + ', hotel=' + tc47.statutoryHotelExpenses + ', total=' + tc47.totalActualTripExpenses,
    passed: tc47.totalDailyExpenses === 216.00 && tc47.statutoryHotelExpenses === 216.00 && tc47.totalActualTripExpenses === 432.00,
  });

  return {
    passed: testResults.filter(t => t.status === 'PASSED').length,
    total: testResults.length,
    details: testResults,
  };
}
